import { Link, useParams } from "react-router-dom";
import { ArrowLeft, ArrowRight } from "lucide-react";
import Reveal from "../components/Reveal";
import { BLOG_POSTS } from "../data/products";

export default function BlogDetail() {
  const { slug } = useParams();
  const post = BLOG_POSTS.find((p) => p.slug === slug);
  const others = BLOG_POSTS.filter((p) => p.slug !== slug).slice(0, 3);

  if (!post) {
    return (
      <div className="pt-40 pb-24 container-luxe text-center">
        <h2 className="font-serif text-4xl text-brand-charcoal">Article not found.</h2>
        <Link to="/blog" className="mt-8 luxe-btn-outline text-brand-green border-brand-green hover:bg-brand-green hover:text-brand-ivory inline-flex">
          Back to Journal <ArrowRight className="w-4 h-4" />
        </Link>
      </div>
    );
  }

  return (
    <>
      {/* HERO */}
      <section className="pt-32 pb-16 bg-brand-ink text-brand-ivory relative overflow-hidden">
        <div className="absolute inset-0 opacity-40">
          <img src={post.cover} alt="" className="w-full h-full object-cover" />
        </div>
        <div className="absolute inset-0 bg-gradient-to-b from-brand-ink/70 via-brand-ink/60 to-brand-ink" />
        <div className="container-luxe relative max-w-3xl">
          <Reveal>
            <Link to="/blog" className="inline-flex items-center gap-2 text-[11px] tracking-[0.22em] uppercase text-brand-ivory/60 hover:text-brand-gold mb-10" data-testid="blog-back">
              <ArrowLeft className="w-3.5 h-3.5" /> The Journal
            </Link>
            <span className="overline">{post.category} · {post.read_time}</span>
            <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl mt-6 leading-[1.05]">{post.title}</h1>
            <div className="mt-8 text-[12px] tracking-[0.22em] uppercase text-brand-ivory/50">{post.date}</div>
          </Reveal>
        </div>
      </section>

      {/* CONTENT */}
      <section className="py-24 bg-brand-ivory">
        <div className="container-luxe max-w-3xl">
          <Reveal className="space-y-8 text-brand-charcoal/80 text-[18px] leading-[1.85]">
            {post.content.map((para, i) => (
              <p key={i} className="first:text-[20px] first:leading-[1.8] first:text-brand-charcoal/90 first:font-serif first:italic">
                {para}
              </p>
            ))}
          </Reveal>
        </div>
      </section>

      {/* OTHERS */}
      <section className="py-24 bg-brand-ivory-warm">
        <div className="container-luxe">
          <Reveal className="mb-12">
            <span className="overline">Continue reading</span>
            <h3 className="font-serif text-3xl mt-4 text-brand-charcoal">More from the Journal.</h3>
          </Reveal>
          <div className="grid md:grid-cols-3 gap-8">
            {others.map((p, i) => (
              <Reveal key={p.slug} delay={i * 60}>
                <Link to={`/blog/${p.slug}`} className="group block" data-testid={`blog-other-${p.slug}`}>
                  <div className="relative aspect-[4/3] overflow-hidden bg-brand-ink mb-5">
                    <img src={p.cover} alt="" className="w-full h-full object-cover opacity-85 group-hover:scale-105 transition-transform duration-[900ms]" />
                  </div>
                  <div className="text-[11px] tracking-[0.24em] uppercase text-brand-gold mb-2">{p.category}</div>
                  <h4 className="font-serif text-xl text-brand-charcoal group-hover:text-brand-green transition-colors">{p.title}</h4>
                </Link>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
